import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SaveAsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"save_as"}/>
}
